import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid } from '@mui/material'

import BaseDialog from '../../BaseDialog'

import { useDataApi } from '../../../context/DataApiContext'
import { useNotificationsProvider } from '../../../context/NotificationsContext'

export default function ModifyEmailDialog({
  open,
  onClose,
  onModified,
  emailToEdit,
}) {
  const { t } = useTranslation()

  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [email, setEmail] = useState(emailToEdit && emailToEdit.email)

  const resource = 'emails' + (emailToEdit && '/' + emailToEdit.id) + '/edit'

  const resetState = () => {
    // Clean form
    setLoading(false)
    setError('')
    setEmail(emailToEdit && emailToEdit.email)
  }

  const onCloseDialog = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose()
    } else {
      resetState()
      onClose()
    }
  }

  const onConfirm = () => {
    if (email.length === 0) {
      setError('email_required')
      return
    }

    const body = {
      data: {
        email,
      },
    }

    setLoading(true)
    dataProvider
      .put(resource, body)
      .then(() => {
        dataProvider.cache.reset()
        showNotification('success', t('modify-email-dialog.success'))
        onModified()
        resetState()
      })
      .catch((err) => {
        if (err.response.data.error === 'EMAIL_ALREADY_EXISTS') {
          showNotification(
            'error',
            t('modify-email-dialog.already-exists-error')
          )
        } else if (err.response.data.error === 'EMAIL_NOT_FOUND') {
          showNotification('error', t('modify-email-dialog.not-found-error'))
        } else {
          showNotification('error', t('errors.api-error'))
        }

        setLoading(false)
      })
  }

  useEffect(() => {
    if (emailToEdit) {
      setEmail(emailToEdit.email)
    }
  }, [emailToEdit])

  return (
    <BaseDialog
      open={open}
      onClose={onCloseDialog}
      onConfirm={onConfirm}
      title={t('modify-email-dialog.title')}
      loading={loading}
    >
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <TextField
            variant="standard"
            required
            error={error === 'email_required'}
            helperText={t('common.required')}
            id="email"
            label={t('modify-email-dialog.email')}
            fullWidth
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}
